<template>
  <breadCrumbs title="Ecommerce Dashboard" main="Dashboard" title1="Ecommerce" />


  <div class="container-fluid ecommerce-page">
    <div class="row">
      <esalesPage />
      <recentPage />
      <topproductPage />
      <salecountryPage />
      <bestsellerPage />
      <div class="col-xxl-4 col-xl-5 col-md-7 box-col-40">

        <productPage />
        <div class="row">
          <div class="col-xl-12">
            <div class="card product-review">
              <div class="card-body">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <div class="img-wrapper"><img class="img-fluid" src="@/assets/images/dashboard-2/person1.png"
                        alt="person1"></div>
                  </div>
                  <div class="person-detail"><router-link to="/users/profile">
                      <h4>Johanna Parvez</h4>
                    </router-link>
                    <ul class="rating-star">
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                      <li><i class="fa fa-star"></i></li>
                    </ul><i class="fa fa-quote-right fa-5x quote-icon"></i>
                  </div>
                </div>
                <div class="product-detail">
                  <p>I love this good looking shoes, but comfort is where it’s at for Me. I can’t say how well they are
                    for playing football , but for everyday wear they are amazing. I think they’re more comfortable than
                    My lebron 17s.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-5 box-col-30">
        <div class="card weekend-view">
          <div class="card-body">
            <div class="inner-bg"></div>
            <div class="img-wrapper"> <img class="img-fluid" src="@/assets/images/dashboard-2/headphone.png"
                alt="headphone"></div>
            <div class="product-detail">
              <h3>Special Weekend Offer</h3>
              <h5>Upto 50% Off Discount</h5><router-link class="btn" to="/ecommerce/product/list">See More</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import esalesPage from './esalesPage.vue'
import recentPage from './recentPage.vue'
import topproductPage from './topproductPage.vue'
import salecountryPage from './salecountryPage.vue'
import bestsellerPage from './bestsellerPage.vue'
import productPage from './productPage.vue'
export default {
  components: {
    esalesPage,
    recentPage,
    topproductPage,
    salecountryPage,
    bestsellerPage,
    productPage
  },
  name: 'indexEcommerce'
}
</script>